import ChevronDownIcon from 'assets/chevron-down.svg';

import classes from './style.module.css';

interface BreadcrumbProps {
  links: { text: string, href: string }[];
  title: string;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  links, title,
}) => {
  return (
    <div className="flex flex-col">
      <nav className={classes.navbar}>
        {links.map((link) => (
          <>
            <a className={classes.breadcrumbLink} href={link.href}>{link.text}</a>
            <img src={ChevronDownIcon} alt="right" className={classes.right} />
          </>
        ))}
      </nav>
      <h1 className={classes.title}>
        {title}
      </h1>
    </div>
  );
};
